export enum InterfaceMessageTypes {
    ERROR,
    SUCCESS,
    WARNING,
}
